import React from "react";
import dislike from "../../../../assets/imgs/dislike_active.svg";
import like from "../../../../assets/imgs/like.svg";
import likeInactive from "../../../../assets/imgs/like-inactive.svg";
import dislikeInactive from "../../../../assets/imgs/dislike.svg";
import { hapticsImpactLight } from "../Services";
import { useSocket } from "../../../../Context/SocketContext/SocketProvider";
import { useMixpanel } from "../../../../Context/MixpanelContext/MixpanelProvider";

interface LikeDislikeButtonsProps {
  checkpointId: string | null;
  threadId: string | null;
  likeClicked: boolean;
  dislikeClicked: boolean;
  likeAnimating: boolean;
  dislikeAnimating: boolean;
  setLikeClicked: (value: boolean) => void;
  setDislikeClicked: (value: boolean) => void;
  setLikeAnimating: (value: boolean) => void;
  setDislikeAnimating: (value: boolean) => void;
}

const LikeDislikeButtons: React.FC<LikeDislikeButtonsProps> = ({
  checkpointId,
  threadId,
  likeClicked,
  dislikeClicked,
  likeAnimating,
  dislikeAnimating,
  setLikeClicked,
  setDislikeClicked,
  setLikeAnimating,
  setDislikeAnimating,
}) => {
  const { likeMessage } = useSocket();
  const Mixpanel = useMixpanel();
  const handleLikeClick = async () => {
    // If already liked, don't do anything
    if (likeClicked) return;

    hapticsImpactLight();
    setLikeClicked(true);
    setDislikeClicked(false);

    // Trigger animation
    setLikeAnimating(true);
    setTimeout(() => setLikeAnimating(false), 300);

    try {
      // Only use WebSocket method for feedback
      Mixpanel.trackEvent("chatbot_response_liked", { name : "User Liked Chatbot Response" });
      likeMessage(true, checkpointId, threadId);
    } catch (error) {
      console.error("Error liking chatbot response:", error);
    }
  };

  const handleDislikeClick = async () => {
    // If already disliked, don't do anything
    if (dislikeClicked) return;

    hapticsImpactLight();
    setDislikeClicked(true);
    setLikeClicked(false);

    // Trigger animation
    setDislikeAnimating(true);
    setTimeout(() => setDislikeAnimating(false), 300);

    try {
      // Only use WebSocket method for feedback
      Mixpanel.trackEvent("chatbot_response_disliked", { name : "User Disliked Chatbot Response" });
      likeMessage(false, checkpointId, threadId);
    } catch (error) {
      console.error("Error disliking chatbot response:", error);
    }
  };

  return (
    <div className="mt-8 flex items-center justify-center gap-[15px]">
      <div>
        <span className="text-white text-[13px] font-semibold">
          Did you like this response?
        </span>
      </div>
      <div className="flex items-center gap-2.5">
        <div
          className={`w-[24.96px] h-[24.96px] cursor-pointer rounded-[6px] bg-white/10 flex items-center justify-center transition-all duration-300 ${likeClicked ? "bg-white/20" : ""}`}
          onClick={handleLikeClick}
        >
          <img
            src={likeClicked ? like : likeInactive}
            alt="like"
            className={`transition-all ${likeClicked ? "w-[14.73px] h-[13.48px]" : "w-[13.48px] h-[12.23px]"}  duration-300 ${
              likeAnimating
                ? "scale-90 rotate-[10deg]"
                : "hover:scale-105 hover:rotate-[-5deg]"
            } `}
          />
        </div>
        <div
          className={`w-[24.96px] h-[24.96px] cursor-pointer rounded-[6px] bg-white/10 flex items-center justify-center transition-all duration-300 ${dislikeClicked ? "bg-white/20" : ""}`}
          onClick={handleDislikeClick}
        >
          <img
            src={dislikeClicked ? dislike : dislikeInactive}
            alt="dislike"
            className={`transition-all ${dislikeClicked ? "w-[14.73px] h-[13.48px]" : "w-[13.48px] h-[12.23px]"} duration-300 ${
              dislikeAnimating
                ? "scale-90 rotate-[-10deg]"
                : "hover:scale-105 hover:rotate-[5deg]"
            } `}
          />
        </div>
      </div>
    </div>
  );
};

export default LikeDislikeButtons;
